import {Component, Inject, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import * as _ from 'lodash';

@AcDialog({
  width: 400,
})
@Component({
  selector: 'sortable-list-dialog',
  templateUrl: './sortable-list-dialog.component.html',
  styleUrls: ['./sortable-list-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class SortableListDialogComponent implements OnInit {

  data;
  oldListOrder;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private userPrivilege: UserPrivilegeService) {
    this.data = dialogConfig.dialogData;

    this.orderedList = _.cloneDeep(this.data.groups);
    this.itemId = this.data.selectedGroup;
    this.filteredList = this.data.filteredList ? _.cloneDeep(this.data.filteredList) : null;

    dialogConfig.submitButtonDisabled = true;
    this.oldListOrder = this.orderedList.map((item) => item.id);

    dialogConfig.preSubmit = () => {
      this.updateParameters(this.data.sentParameters);
      /*

      throw new Error();
       */
      return true;
    };
  }

  @Input()
  openEventName: string;

  @Input()
  closeEventName: string;

  @Input()
  dialogTitle: string;

  @Input()
  labeledValue = 'name';

  orderedList: any;
  filteredList: any;
  itemId: number;


  onOk: () => void;
  canSubmit: boolean;

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
  }

  onItemListChanged(items): void {
    this.orderedList = items;
    if (this.oldListOrderHasNotChanged()){
      this.dialogConfig.submitButtonDisabled = true;
    }
    else{
      this.dialogConfig.submitButtonDisabled = false;
    }
  }

  private notLast(value): boolean {
    return this.orderedList.indexOf(value) < this.orderedList.length - 1;
  }

  private notFirst(value): boolean {
    return this.orderedList.indexOf(value) > 0;
  }

  private updateParameters(parameters): void {
    const itemToMove =  this.orderedList.find((item) => item.id === this.itemId);
    const index = this.orderedList.findIndex(item => item.id === itemToMove.id);

    if (this.notFirst(itemToMove)) {
      parameters.prevId = this.orderedList[index - 1].id;
    }
    if (this.notLast(itemToMove)) {
      parameters.nextId = this.orderedList[index + 1].id;
    }
    parameters.currentIndex = index;
  }

  private oldListOrderHasNotChanged(): boolean{
    const newOrderList = this.orderedList.map((item) => item.id);
    return _.isEqual(this.oldListOrder, newOrderList);
  }

}
